// Copyright 2019 Drivetrain Hub LLC

import Vue from 'vue';

/**
 * BROWSER CHANNELS
 *  - 'rename-part': {part} to update part name.
 *
 * MODELER CHANNELS
 *  - 'assign-basic-rack': {basicRack} to assign basic rack.
 *  - 'assign-shaper': {shaper} to assign shaper tool.
 *  - 'assign-hob': {hob} to assign hob tool.
 *
 * 3D VIEWER CHANNELS - PART EVENTS
 *  - 'add-part': {part} to add to the 3D scene.
 *  - 'move-part': {part} to move in the 3D scene.
 *  - 'update-part': {part} to update in the 3D scene.
 *  - 'redraw-part': {part} to redraw in the 3D scene.
 *  - 'remove-parts': {arrId} to remove from the 3D scene.
 *
 * 3D VIEWER CHANNELS - CONN EVENTS
 *  - 'add-connection': {conn} to add to the 3D scene.
 *  - 'remove-connection': {conn} to remove from the 3D scene.
 *
 * 3D VIEWER CHANNELS - APP EVENTS
 *  - 'render': call render method for 3D scene.  Used to avoid loss of render when toggling tabs.
 *  - 'reset-modeling': clear 3D scene and redraw.  Used to update 3D scene between opening models/releases.
 *
 * 3D VIEWER CHANNELS - VIEW EVENTS
 *  - 'zoom-to-fit': {Id} optional part to zoom and focus on in the 3D scene, otherwise fit all.
 *  - 'view': {string} view command for 3D scene: 'isometric', 'zoom to fit', 'shaded', etc.
 */
export const EventBus = new Vue({
  methods: {
    emit(eventName, value) {
      // https://forum.vuejs.org/t/do-something-after-emit-has-finished-successful/10663/6
      return new Promise((resolve) => {
        this.$emit(eventName, value);
        this.$nextTick(resolve);
      })
    }
  }
});
